import React from 'react';
export default function Image(props) {
    return (React.createElement("img", { className: "renderer-image", src: props.src, alt: props.alt, title: props.title }));
}
//# sourceMappingURL=image.js.map